import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "hooks/morning/axiosInstanse";

interface NoticesRequest {
    category: string;
    limit: number;
    page: number;
    // search: "subject" | "contents";
    search: string;
    searchtxt: string;
    notice?: 1; // 1이면 공지 설정 글만 조회
}
export type DataListProps = {
    list_no: number;
    subject: string;
    counter: number;
    notice: number;
    w_date: string;
};

export interface NoticesResponseData {
    limit: number;
    current_page: number;
    start_page: number;
    max_page: number;
    last_page: number;
    end_page: number;
    total_count: number;
    data_list: DataListProps[];
}

export const useGetNotices = ({ category, search, searchtxt, page, limit, notice }: NoticesRequest): UseQueryResult<NoticesResponseData, Error> => {
    let url = enum_api_uri.get_notices.replace(":category", category);
    return useQuery({
        queryKey: ["useGetNotices", category, search, searchtxt, page, limit, notice],
        queryFn: async () => {
            const response = await axiosInstance.get(url, {
                params: {
                    search,
                    searchtxt,
                    page,
                    limit,
                    notice,
                },
            });
            return response.data.data;
        },
    });
};
